import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import React from "react";
import AcxToggleButton from "components/UI/AcxToggleButton";

export const EddyEffectFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    return (
        <AcxToggleButton
            id="application-filters-eddy-effect"
            exclusive
            items={[
                {
                    id: "application-filters-eddy-effect-is-present",
                    element: "Is Present",
                    value: true,
                },
                {
                    id: "application-filters-eddy-effect-is-not-present",
                    element: "Is Not Present",
                    value: false,
                },
            ]}
            onChange={(value?: boolean) => {
                props.store.setEddyEffectStatus(value);
            }}
            defaultValue={props.store.eddyEffectStatus}
            justifyContent="center"
            groupFlexGrow={1}
        />
    );
});
